import { createFileRoute } from "@tanstack/react-router"
import { Content } from "@/content"

export const Route = createFileRoute("/(public)/content/$slug")({
  component: RouteComponent,
})

function RouteComponent() {
  const { slug } = Route.useParams()

  return <Content slug={slug} />
}
